import { useTranslation } from 'react-i18next';
import MaterialButton from './maker/component/MaterialButton';
import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from "react-router";
import { webFallback } from '.';
import * as Sentry from "@sentry/react";
import LineBreak from './maker/component/LineBreak';

function shouldReportRouteErrorToSentry(error) {
    if (error == null) {
        return false;
    }
    if (isRouteErrorResponse(error)) {
        return error.status >= 500;
    }
    const message = typeof error === "string"
        ? error
        : (error.message || "");
    if (!message) {
        return false;
    }
    const lower = message.toLowerCase();
    if (lower.includes("no routes matched") || lower.includes("not found")) {
        return false;
    }
    return true;
}

function ErrorPageWithRedirect(props) {    
    const { t } = useTranslation();
    
    document.getElementsByTagName('body')[0].className = 'PatternBackground';
    
    const error = useRouteError();

    useEffect(() => {
        if (shouldReportRouteErrorToSentry(error)) {
            const detail = typeof error === "string"
                ? error
                : (error?.message || String(error));
            Sentry.captureMessage(
                "error leading to a redirect (this error may create a duplicate) :  " + detail
            );
        }
    }, [error]);

    useEffect(() => {
        setTimeout(()=>{            
            if (webFallback){
                window.location = webFallback;
            }
            }, 1000);        
      }, []);

    return (
      <div style={{width: 360, height: 360, borderRadius:60, display: "flex", flexDirection: "column", justifyContent: 'center', alignItems: 'center', alignContent: 'center', transform: 'translate(-50%, -50%)', position: 'absolute', top: '50%', left: '50%', background: 'white'}}>
            <img src="/images/img_error.png" alt={t('ErrorImageAlt')} style={{width: 128, height: 128 }}/>
            <LineBreak/>
            <div style={{fontSize: 18}}>{t('ErrorTitle')}</div>
            <LineBreak/>
            <div style={{fontSize: 14}}>{t('ErrorMsg')}</div>
            <LineBreak/>
            <div>
                <MaterialButton style="filled" onClick={() => window.location.reload()}  value={t('ErrorAction')} />                        
            </div>
        </div>
    );
}

export default ErrorPageWithRedirect;